export default __webpack_public_path__ + "static/media/conference-room-Icon.71c860a0.svg";